export const BASE_URL =
  window.location.host.indexOf("localhost") < 0
    ? window.location.protocol + "//" + window.location.host
    : "https://dashboard.quanqiupay.com";

export default {
  GETCODE: "/api/captcha.php", //生成验证码
  LOGIN: "/api/login.php", //登录
  GETUSERINFO: "/api/user.php", //获取用户信息

  //账户
  ACCOUNTMANAGE: "/api/merchant_accounts.php", //账户管理
  GETACCOUNTDETAILS: "/api/merchant_account_detail.php", // 获取账户详情

  //交易
  GETTRANSACTIONSLIST: "/api/transactions_list.php", // 获取交易列表
  GETTRANSACTIONDETAIL: "/api/transaction_detail.php", // 获取交易详情

  // 消息中心
  MESSAGES_LIST: "/api/messages_list.php", // 获取消息列表
  MESSAGE_DETAIL: "/api/message_detail.php", // 获取消息详情（自动标记已读）
  MARK_MESSAGE_READ: "/api/mark_message_read.php", // 标记消息为已读
  MARK_ALL_READ: "/api/mark_all_read.php", // 标记所有消息为已读
  GET_UNREAD_COUNT: "/api/get_unread_count.php", // 获取未读消息数量
  DELETE_MESSAGE: "/api/delete_message.php", // 删除消息
};
